import DashboardFinanciero from "../../components/DashboardFinanciero";

const DashboardFinancieroPage = () => <DashboardFinanciero />;

export default DashboardFinancieroPage;
